import { useQuery } from "react-query";
import { getNoteDetails } from "../../../api/services";

export const useNoteDetails = (accountNumber: string, noteId: string) => {
  return useQuery(
    ["accounts/note", { accountNumber, noteId }],
    getNoteDetails,
    {
      enabled: !!accountNumber && !!noteId,
    },
  );
};
